import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Users, Layers, StickyNote, TrendingUp, GraduationCap, Award } from "lucide-react";
import StudentsTab from "./admin/StudentsTab";
import SequenceTab from "./admin/SequenceTab";
import MemosTab from "./admin/MemosTab";
import PendingPanel from "./admin/PendingPanel";
import AlertsPanel from "./admin/AlertsPanel";
import ClassProgressTab from "./admin/ClassProgressTab";
import FinalGradesTab from "./admin/FinalGradesTab";

export default function AdminPage() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 mz-rise">
      <div className="flex items-center gap-3">
        <div className="h-12 w-12 rounded-2xl bg-sky-100 text-sky-600 flex items-center justify-center"><GraduationCap className="h-6 w-6" /></div>
        <div>
          <p className="text-sm font-bold text-sky-500 uppercase tracking-wide">Espace professeur</p>
          <h1 className="font-display text-3xl font-semibold text-slate-900">Tableau de bord</h1>
        </div>
      </div>

      <PendingPanel />
      <AlertsPanel />

      <Tabs defaultValue="students" className="mt-2">
        <TabsList className="bg-slate-100 rounded-full p-1 h-auto">
          <TabsTrigger value="students" className="rounded-full px-4 py-2 font-bold data-[state=active]:bg-white data-[state=active]:text-orange-600" data-testid="tab-students"><Users className="h-4 w-4 mr-1.5" /> Élèves</TabsTrigger>
          <TabsTrigger value="sequence" className="rounded-full px-4 py-2 font-bold data-[state=active]:bg-white data-[state=active]:text-orange-600" data-testid="tab-sequence"><Layers className="h-4 w-4 mr-1.5" /> Séquence</TabsTrigger>
          <TabsTrigger value="progress" className="rounded-full px-4 py-2 font-bold data-[state=active]:bg-white data-[state=active]:text-orange-600" data-testid="tab-progress"><TrendingUp className="h-4 w-4 mr-1.5" /> Progression</TabsTrigger>
          <TabsTrigger value="memos" className="rounded-full px-4 py-2 font-bold data-[state=active]:bg-white data-[state=active]:text-orange-600" data-testid="tab-memos"><StickyNote className="h-4 w-4 mr-1.5" /> Mémos</TabsTrigger>
          <TabsTrigger value="final-grades" className="rounded-full px-4 py-2 font-bold data-[state=active]:bg-white data-[state=active]:text-orange-600" data-testid="tab-final-grades"><Award className="h-4 w-4 mr-1.5" /> Notes finales</TabsTrigger>
        </TabsList>
        <TabsContent value="students" className="mt-6"><StudentsTab /></TabsContent>
        <TabsContent value="sequence" className="mt-6"><SequenceTab /></TabsContent>
        <TabsContent value="progress" className="mt-6"><ClassProgressTab /></TabsContent>
        <TabsContent value="memos" className="mt-6"><MemosTab /></TabsContent>
        <TabsContent value="final-grades" className="mt-6"><FinalGradesTab /></TabsContent>
      </Tabs>
    </div>
  );
}
